import React from 'react';

/**
 * Desktop tab button component for filtering leads.
 */
export const TabButton = ({ children, active, onClick }) => (
    <button
        onClick={onClick}
        className={`px-3 py-2 text-xs font-medium border-b-2 transition-colors flex items-center gap-1 ${active ? 'border-stone-800 text-notion-text' : 'border-transparent text-notion-text-light hover:text-stone-600'
            }`}
    >
        {children}
    </button>
);

export default TabButton;
